import React from 'react';
import { Layout } from 'antd';

import { RouterContext } from '../../context';

import Header from './components/Header';
import Content from '../common/Content';
import './index.scss';

const BASE_CLS = 'creative-tool-layout';
const CreativeToolLayout = ({ systemConfig, state, dispatch, ...props }) => (
  <div className={BASE_CLS}>
    <Layout className={`${BASE_CLS}-wrap`}>
      <RouterContext.Provider value={[state, dispatch]}>
        <Header {...props} {...state} />
        <Layout className={`${BASE_CLS}-content`}>
          <Content />
        </Layout>
      </RouterContext.Provider>
    </Layout>
  </div>
);
export default CreativeToolLayout;
